import { render } from "./WisdomCare.vue?vue&type=template&id=18e97999&scoped=true"
import script from "./WisdomCare.vue?vue&type=script&lang=js"
export * from "./WisdomCare.vue?vue&type=script&lang=js"

import "./WisdomCare.vue?vue&type=style&index=0&id=18e97999&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e97999"]])

export default __exports__